export default __webpack_public_path__ + "static/media/ponentes___Edgar-Runnebaum.01dfbcab.jpg";